import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Contactpersoon } from '../types/Contactpersoon'

export { updateContactpersoonForEntity }

async function updateContactpersoonForEntity({
  contactpersoon,
  entity,
}: {
  contactpersoon: Contactpersoon
  entity: Entity
}): Promise<Contactpersoon> {
  const { type, id } = entity
  const { _id } = contactpersoon

  const { data } = await apiClient({
    url: `/rest/${type}/${id}/contactpersoon/${_id}`,
    method: 'PATCH',
    data: { ...contactpersoon, _id: undefined, status: undefined },
  })

  return data
}
